enum EnumTypeUser {
  /// Физ лицо
  NaturalPerson = 1,
  /// Юр-лицо
  LegalPerson = 2,
}
export default EnumTypeUser;